import { zodFlavorId } from "./ids.mjs";
import { defineFirestoreCollection } from "./firebaseCollectionSchema.mjs";
import { PiiCategory, meta } from "./meta.mjs";
import z from "zod";

// src/models/instructor.ts
const instructorSchema = z.object({
	id: zodFlavorId(),
	firstName: meta(z.string(), { pii: { category: "name" } }),
	lastName: meta(z.string(), { pii: { category: "name" } }),
	bio: meta(z.string(), { pii: { category: "freeText" } }),
	profilePictureUrl: meta(z.string(), { pii: { category: "image" } }),
	hidden: meta(z.boolean(), { excludeFromBqSchema: true }),
	userId: zodFlavorId().nullable()
});
/**
* Instructors collection definition
* Path: instructors/{instructorId}
*/
const Instructors = defineFirestoreCollection("instructors", instructorSchema, void 0, {
	dwReplication: true,
	firestoreCollectionPath: "instructors"
});
var InstructorEnriched = class InstructorEnriched {
	static fromInstructor(instructor) {
		return new InstructorEnriched(instructor);
	}
	instructor;
	constructor(instructor) {
		this.instructor = instructor;
	}
	get fullName() {
		return `${this.instructor.firstName} ${this.instructor.lastName}`;
	}
};

export { InstructorEnriched, Instructors, instructorSchema };
//# sourceMappingURL=instructor.mjs.map